enum BiteLogElavonEvent {
  None = 0,
  TerminalDisconnected = 1,
  UpdateIdleTextError = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  TerminalConnected = 5,
  NoResponseReceived = 6,
  InquiryTransaction = 7,
  InquiryTransactionError = 8,
  CancelTransaction = 9,
  CancelTransactionError = 10,
  GetOrSaveReferenceSequenceFailed = 11,
  OptConnectFailure = 12,
}

export { BiteLogElavonEvent };
